import _ from 'lodash';
import {loop, Effects} from 'redux-loop';
import {FETCH_FEED, FETCH_FEED_SUCCESS, FETCH_FEED_FAIL, FETCH_QUERY, FETCH_QUERY_SECCESS, FETCH_QUERY_FAIL} from './actions';
import {fetchFeed, fetchQuery} from './tasks';

export const initialState = {
  data: [],
  count: 0,
  isLoading: false,
  isAppend: false,
};

export default (
  state = initialState,
  action,
) => {
  if (action.type === FETCH_FEED) {
    return loop({
      ...state,
      isLoading: true,
    },
      Effects.promise(fetchFeed, {
        query: action.isAppend
          ? {...action.query, offset: state.data.length}
          : action.query,
        isAppend: action.isAppend,
      })
    );
  }

  if (action.type === FETCH_FEED_SUCCESS) {
    return loop({
      isLoading: false,
      count: action.count,
      data: action.isAppend
        ? [...state.data, ...action.data]
        : action.data,
    },
      Effects.none()
    );
  }

  if (action.type === FETCH_FEED_FAIL) {
    return loop({
      ...state,
      error,
      isLoading: false,
    },
      Effects.none()
    );
  }

  if (action.type === FETCH_QUERY) {
    return loop({
      ...state,
    },
      Effects.promise(fetchQuery, {q: action.query})
    );
  }

  if (action.type === FETCH_QUERY_SECCESS) {
    return loop({
      ...state,
      querySyntax: true
    },
      Effects.none()
    )
  }

  if (action.type === FETCH_QUERY_FAIL) {
    return loop({
      ...state,
      querySyntax: false
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/reducer.js
 **/